import { baseUrl } from './routes';

export class CalendarRoutes {
  static get calendar(): string {
    return `${baseUrl}/calendar`;
  }
  static get view(): string {
    return `${baseUrl}/calendar/view`;
  }
  static get parentView(): string {
    return `${baseUrl}/parent`;
  }
}